import { Form, Visual } from './components'

import styles from './styles.module.scss'

const Login = () => {
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <Visual />
        <Form />
      </div>
    </div>
  )
}

export default Login